// extracted by mini-css-extract-plugin
module.exports = {"installments":"styles_installments__2lnZN","error":"styles_error__3iahD"};